import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { ExternalLink, Video, Music, Image, Film, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

const SitesUsadosSection = () => {
  const featuredSites = [
    {
      id: "vheer",
      title: "VHEER",
      description: "Transforme imagens em vídeos com animações realistas.",
      link: "https://vheer.com/app/image-to-video",
      icon: <Film className="h-5 w-5 text-primary" />
    },
    {
      id: "clideo",
      title: "CLIDEO",
      description: "Editor de vídeo online com várias ferramentas para edição profissional.",
      link: "https://clideo.com/",
      icon: <Film className="h-5 w-5 text-primary" />
    },
    {
      id: "suno",
      title: "SUNO AI",
      description: "Gerador de música com inteligência artificial.",
      link: "https://suno.com/invite/@dumbstruckvinyl155",
      icon: <Music className="h-5 w-5 text-primary" />
    },
    {
      id: "oneimagevideo",
      title: "ONE IMAGE VIDEO",
      description: "Transforme uma única imagem em um vídeo com movimento e efeitos.",
      link: "https://www.oneimagevideo.com/",
      icon: <Image className="h-5 w-5 text-primary" />
    }
  ];

  return (
    <section className="py-12 px-4 md:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 mb-8">
          <div>
            <h2 className="text-3xl font-bold">Sites Úteis para Criação</h2>
            <p className="text-muted-foreground mt-2">
              Ferramentas essenciais para criação de conteúdo digital
            </p>
          </div>
          <Button asChild variant="outline" className="border-primary text-primary hover:bg-primary/10">
            <Link to="/sites-usados">
              Ver Todos os Sites
              <ArrowRight className="ml-2 h-4 w-4" />
            </Link>
          </Button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {featuredSites.map((site) => (
            <Card key={site.id} className="h-full flex flex-col border-border hover:shadow-md transition-shadow">
              <CardHeader className="pb-2">
                <div className="flex items-center gap-3">
                  {site.icon}
                  <CardTitle className="text-lg">{site.title}</CardTitle>
                </div>
              </CardHeader>
              <CardContent className="flex-grow">
                <CardDescription>{site.description}</CardDescription>
              </CardContent>
              <CardFooter className="pt-0">
                <Button asChild variant="ghost" className="w-full justify-start hover:bg-primary/10 hover:text-primary">
                  <a href={site.link} target="_blank" rel="noopener noreferrer">
                    <ExternalLink className="mr-2 h-4 w-4" />
                    Visitar Site
                  </a>
                </Button>
              </CardFooter>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SitesUsadosSection;